import { memo } from 'react'
import { NotebookText } from 'lucide-react'
import type { ChatAttachment, FinalizedAttachment } from '../../../../types'
import { FadingScrollable } from '../../../elements/FadingScrollable'
import { PreviewableContext } from '../../input/context/previewable-context'
import { AttachmentStub } from '../attachment-stub'
import { useRemoveAttachment } from '../hooks/use-remove-attachment'
import { scrollableAreaClassName, scrollablePreviewClassName } from '../styles'
import type { AttachmentPillProps } from '../types'

export const SummaryAttachment = memo((attachment: AttachmentPillProps) => {
  const onRemove = useRemoveAttachment(attachment)

  const label = attachment.metadata?.label ?? 'Summary'

  return (
    <PreviewableContext preview={<SummaryPreview {...attachment} />}>
      <AttachmentStub label={label} icon={<NotebookText size={16} />} onRemove={onRemove} />
    </PreviewableContext>
  )
})
SummaryAttachment.displayName = 'SummaryAttachment'

const SummaryPreview = memo((attachment: ChatAttachment) => {
  const summary = attachment.attachment as Extract<FinalizedAttachment, { type: 'dailySummary' }>
  return (
    <div className={scrollablePreviewClassName}>
      <FadingScrollable className={scrollableAreaClassName} onClick={(e) => e.stopPropagation()}>
        {summary.summary}
      </FadingScrollable>
    </div>
  )
})
SummaryPreview.displayName = 'SummaryPreview'
